import { render, staticRenderFns } from "./pay-modal.vue?vue&type=template&id=285c0af2"
import script from "./pay-modal.vue?vue&type=script&lang=js"
export * from "./pay-modal.vue?vue&type=script&lang=js"
import style0 from "./pay-modal.vue?vue&type=style&index=0&id=285c0af2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports